<div
  #linkContainer
  class="nav-container"
  (mouseover)="subOpen()"
  (mouseout)="subClose()"
  role="menuitem"
  [attr.aria-label]="link()?.linkText"
>
  <div
    #linkElem
    class="nav-item-link"
    data-cy="navigationMenuItem"
    [style.maxWidth.px]="link()?.maxWidth"
    [class.has-children]="!!link()?.subLinkArray?.length"
    [class.overflow-ellipsis]="link()?.overflowEllipsis"
    [class]="link()?.listClasses"
  >
    @if (!link()?.linkExternalUrl && !link()?.mobileOnly && link()?.showOnNavigationMenu) {
      @if (link()?.linkRoute) {
        <a
          [dsRouterLink]="link()?.linkRoute"
          [queryParams]="link()?.queryParams"
          [class]="link()?.linkClasses + '-text'"
          [attr.aria-label]="link()?.linkText"
          [attr.aria-expanded]="submenuHasPopup() ? submenuExpanded() : null"
          [attr.aria-haspopup]="submenuHasPopup() ? 'menu' : null"
          [attr.data-cy]="link()?.linkTestId"
          (focus)="subOpen($event.currentTarget)"
          (blur)="subClose($event.currentTarget)"
          (touchstart)="subOpen($event.currentTarget)"
          (click)="linkClick(link(), $event)"
        >
          <div class="link-content">
            @if (!!link()?.linkIcon) {
              <span role="presentation" aria-hidden="true" [class]="link()?.linkIcon"></span>
            }
            <span [class.overflow-ellipsis]="link()?.overflowEllipsis">{{ link()?.linkText }}</span>
          </div>
        </a>
      } @else {
        @if (link()?.linkTestId === 'navItemLogoutLink') {
          <button
            ds-button
            buttonVariant="secondary"
            class="margin-top margin-left-16"
            (focus)="subOpen($event.currentTarget)"
            (blur)="subClose($event.currentTarget)"
            (touchstart)="subOpen($event.currentTarget)"
            (click)="linkClick(link(), $event)"
            [attr.aria-expanded]="submenuHasPopup() ? submenuExpanded() : null"
            [attr.aria-haspopup]="submenuHasPopup() ? 'menu' : null"
          >
            <span
              [class]="link()?.linkClasses + '-text'"
              [attr.aria-label]="link()?.linkText"
              [attr.data-cy]="link()?.linkTestId"
            >
              <div class="link-content">
                @if (!!link()?.linkIcon) {
                  <span role="presentation" aria-hidden="true" [class]="link()?.linkIcon"></span>
                }
                <span [class.overflow-ellipsis]="link()?.overflowEllipsis">{{
                  link()?.linkText
                }}</span>
              </div>
            </span>
          </button>
        } @else {
          <span
            role="button"
            tabindex="0"
            [class]="link()?.linkClasses + '-text'"
            [attr.aria-label]="link()?.linkText"
            [attr.aria-expanded]="submenuHasPopup() ? submenuExpanded() : null"
            [attr.aria-haspopup]="submenuHasPopup() ? 'menu' : null"
            [attr.data-cy]="link()?.linkTestId"
            (focus)="subOpen($event.currentTarget)"
            (blur)="subClose($event.currentTarget)"
            (touchstart)="subOpen($event.currentTarget)"
            (click)="linkClick(link(), $event)"
            (keydown.enter)="linkClick(link(), $event)"
          >
            <div class="link-content">
              @if (!!link()?.linkIcon) {
                <span role="presentation" aria-hidden="true" [class]="link()?.linkIcon"></span>
              }
              <span [class.overflow-ellipsis]="link()?.overflowEllipsis">{{
                link()?.linkText
              }}</span>
            </div>
          </span>
        }
      }
    }
    @if (!!link()?.linkExternalUrl && !link()?.mobileOnly && link()?.showOnNavigationMenu) {
      <a
        [class]="link()?.linkClasses + '-text'"
        [href]="link()?.linkExternalUrl"
        [attr.aria-label]="link()?.linkText"
        [attr.target]="link()?.linkTarget"
        [attr.data-cy]="link()?.linkTestId"
        (click)="linkClick(link(), $event)"
        (focus)="subOpen($event.currentTarget)"
        (blur)="subClose($event.currentTarget)"
      >
        <div class="link-content">
          @if (!!link()?.linkIcon) {
            <span role="presentation" aria-hidden="true" [class]="link()?.linkIcon"></span>
          }
          <span [class.overflow-ellipsis]="link()?.overflowEllipsis">{{ link()?.linkText }}</span>
        </div>
      </a>
    }
    @if (!!link()?.subLinkArray?.length) {
      <ul
        [class.open]="showSub() === 'show'"
        #sublinkElem
        class="nav-item-sublink"
        role="menu"
        [attr.data-cy]="link()?.submenuTestId"
      >
        @for (sublink of link()?.subLinkArray; track $index) {
          <li
            #subLinkElemList
            role="menuitem"
            [class]="sublink?.listClasses"
            [style.maxWidth.px]="sublink?.maxWidth"
          >
            @if (!sublink?.linkExternalUrl && !link()?.mobileOnly) {
              <a
                [dsRouterLink]="sublink?.linkRoute"
                [class]="sublink?.linkClasses"
                [queryParams]="sublink?.queryParams"
                [attr.aria-label]="sublink?.linkText"
                [attr.data-cy]="sublink?.linkTestId"
                (click)="sublinkClick(sublink, $event)"
                (focus)="subOpen($event.currentTarget)"
                (blur)="subClose($event.currentTarget)"
              >
                @if (!!sublink?.linkIcon) {
                  <span
                    role="presentation"
                    aria-hidden="true"
                    alt="Link Icon"
                    [class]="sublink?.linkIcon"
                  ></span>
                }
                <span [class.overflow-ellipsis]="sublink?.overflowEllipsis">{{
                  sublink.linkText
                }}</span>
              </a>
            }
            @if (!!sublink?.linkExternalUrl && !link()?.mobileOnly) {
              <a
                [class]="sublink?.linkClasses"
                [href]="sublink?.linkExternalUrl"
                [attr.aria-label]="sublink?.linkText"
                [attr.target]="sublink?.linkTarget"
                [attr.data-cy]="sublink?.linkTestId"
                (click)="sublinkClick(sublink, $event)"
                (focus)="subOpen($event.currentTarget)"
                (blur)="subClose($event.currentTarget)"
              >
                @if (!!sublink?.linkIcon) {
                  <span
                    role="presentation"
                    aria-hidden="true"
                    alt="Link Icon"
                    [class]="sublink?.linkIcon"
                  ></span>
                }
                <span [class.overflow-ellipsis]="sublink?.overflowEllipsis">{{
                  sublink.linkText
                }}</span>
              </a>
            }
          </li>
        }
      </ul>
    }
  </div>
</div>
